import {Observable, Subscription} from 'rxjs';

import Playback       from '../../Playback/Playback';
import ITimelineStore from '../Interfaces/ITimelineStore';

const subscribeToPlaybackStoreUpdate = (
    playbackUpdate$: Observable<Playback>,
    timelineStore: ITimelineStore
): Subscription =>
    playbackUpdate$
        .subscribe(nextPlayback => timelineStore.actions.derivePlayback(nextPlayback));

export default subscribeToPlaybackStoreUpdate;